import { Bell } from "lucide-react";
import type { Tab } from "@playbookai/ui";
import { NOTIFICATIONS_ROUTE } from "../routes.js";

export const NOTIFICATIONS_TAB_ID = "notifications";

export function notificationsTab(route = NOTIFICATIONS_ROUTE): Tab {
  return {
    id: NOTIFICATIONS_TAB_ID,
    label: "Notifications",
    route,
    icon: Bell,
  };
}
